import { PoolConfig, QuoteToken, PoolCategory } from './types'

const pools: PoolConfig[] = [
  {
    sousId: 0,
    tokenName: 'NEWO',
    tokenAddress: '0x8878A13F19fA7F61AE0BB63F4Ab5ce5D519F67D0',   // token address
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: '0x8878A13F19fA7F61AE0BB63F4Ab5ce5D519F67D0',  // token address
    contractAddress: {
      97: '',
      56: '0x718D504262EC0f3C8da073b3242b12c1b9958acF',  /// masterchef address
    },
    poolCategory: PoolCategory.CORE,
    projectLink: '/',
    harvest: true,
    tokenPerBlock: '10',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
 
]

export default pools
